import { LABELS } from '~/app/constants'

/**
 *
 */
export default function initCounters() {
  const counters = {
    totalPendingComments: 0,
    totalComments: 0,
    labels: [],
  }

  LABELS.forEach(({ id }) => {
    // @ts-expect-error TS(2322) FIXME: Type 'string' is not assignable to type 'never'.
    counters.labels.push({ label: id, count: 0 })
  })

  return counters
}
